import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { EngagementContactInteraction } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';


export function getColumns(util: UtilityService, domainData: DomainDataService, app: AppService) {

	const columns: GridColumn<EngagementContactInteraction & { updatedUTC: number }, unknown>[] = [
		buildColumn(util, 'Date', row => util.date.fromUTC(row.contactedDateUTC), { header: 'Date' }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.staffId), { header: 'Staff Member' }),
		buildColumn(util, 'Text', row => domainData.data().contactMethodMap[row.contactMethodId]?.name, { header: 'Contact Method' }),
		buildColumn(util, 'YesNo', row => row.wasDefaultContactMethod, { header: 'Default Contact Method', hidden: true }),
		buildColumn(util, 'Text', row => row.note, { header: 'Note' }),
	];

	return columns;

}